import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesDetailSection from '../components/ServicesDetailSection';
import QuoteFormSection from '../components/QuoteFormSection';
import FeaturedProjectsSection from '../components/FeaturedProjectsSection';
import ProjectGallerySection from '../components/ProjectGallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import CallToActionSection from '../components/CallToActionSection';
import Footer from '../components/Footer';
export function HomePage() {
  return <>
      <div id="hero" data-id="element-948" data-mp="31zvhapoclmus">
        <HeroSection data-id="element-949" data-mp="31zbwn17bckd2" />
      </div>
      <div id="about" data-id="element-950" data-mp="31yamr021a3wx">
        <AboutSection data-id="element-951" data-mp="31xr1pah36zeo" />
      </div>
      <div id="services" data-id="element-952" data-mp="2e97vr1lieypr">
        <ServicesDetailSection data-id="element-953" data-mp="2e8pzw62remid" />
      </div>
      <div id="work" data-id="element-954" data-mp="29axxuj8ehk0g">
        <ProjectGallerySection data-id="element-955" data-mp="29bg1i0xe70ie" />
      </div>
      <div id="contact" data-id="element-956" data-mp="29ao88wr9peva">
        <QuoteFormSection data-id="element-957" data-mp="2aov4oyvg9bws" />
      </div>
      <FeaturedProjectsSection data-id="element-958" data-mp="2antsus6m0le0" />
      <div id="testimonials" data-id="element-959" data-mp="2aomsl975iamn">
        <TestimonialsSection data-id="element-960" data-mp="2eqgol46eiqgh" />
      </div>
      <WhyChooseUsSection data-id="element-961" data-mp="2epf3s7zl2plk" />
      <CallToActionSection data-id="element-962" data-mp="2eondncor9k2o" />
      <Footer data-id="element-963" data-mp="2jh6x2qa4j9fe" />
    </>;
}